import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("---请选择---")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_select, {
      modelValue: _ctx.val,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.val = $event)),
      placeholder: "请选择",
      class: "m-el-input"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_option, {
          label: "---请选择---",
          value: ''
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item[_ctx.labelAndValue.label],
            value: item[_ctx.labelAndValue.value]
          }, null, 8, ["label", "value"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}